import { defineStore } from 'pinia'
import { ref } from 'vue'

import { CustomerService } from '@/services/admin'
import type { ICustomer } from '@/types'

export const useCustomerStore = defineStore(
  'customer-store',
  () => {
    const customer = ref<ICustomer | null>(null)

    async function setCustomerInfo(id: number) {
      try {
        customer.value = await CustomerService.getSingle(id)
      } catch (error) {
        console.error(error)
        customer.value = null
      }
    }

    return { customer, setCustomerInfo }
  },
  {
    persist: true,
  },
)
